module.exports = __webpack_public_path__ + "img/IMG_9917.e3d6f8de.jpg";